import * as React from 'react'
import { PageHeader, Button} from 'antd'

interface CellLinkProps {
    title: React.ReactNode
}

export const NavigationBar: React.FC<CellLinkProps> = (props) => {
    React.useEffect(() => {
        // Trova il contenitore del back button e aggiorna l'aria-label
        const backBtn = document.querySelector('.ant-page-header-back-button');
        if (backBtn) {
            backBtn.setAttribute('aria-label', 'Indietro');
        }
    }, []);
    return <PageHeader onBack={() => window.history.back()} backIcon={<Button type="primary" shape="circle" >{'<'}</Button>} title={<h1 tabIndex={0}>{props.title}</h1>} />
}